document.addEventListener("DOMContentLoaded", (event) => {
    if(!document.querySelector('.product-information')) return;
    const productInfoColumn = document.querySelector('.product-information');
    
    if(!productInfoColumn.querySelectorAll(".custom-variants--block")) return;
    const customVariantBlocks = productInfoColumn.querySelectorAll(".custom-variants--block");

    if(!document.getElementById("CustomVariantsMetafields")) return;
    //const fieldsData = JSON.parse(document.getElementById("CustomVariantsMetafields").textContent);
    const fieldsData = window.ProductData;
    
    const productForm = document.querySelector('product-form');
    const form = productForm.querySelector('form.form');
    form.addEventListener('change', (event) =>{
    //document.addEventListener("product:variant-change", function (evt) {
        let matchedVariant = fieldsData.variants.find(fieldData => fieldData.id == form.querySelector('[name="id"]').value);
        if(!matchedVariant) return;

        let variantMetafields = matchedVariant.custom_metafields,
            dataKeysELements = productInfoColumn.querySelectorAll(".custom-variant--field[data-key]");

        //console.log("Variants custom metafields", variantMetafields);
        dataKeysELements.forEach(key => {
            let metafieldKey = key.dataset.key,
                metafieldType = key.dataset.metafieldType,
                metafieldValue = (variantMetafields[metafieldKey]) ? variantMetafields[metafieldKey] : "",
                customBadgesParent = key.querySelector(".custom-badges");

            customBadgesParent.innerHTML = " ";

            if(!metafieldKey) {
                key.classList.add('hidden');
            }

            if(metafieldType == "rich_text_field" && metafieldValue) {
                let richTextValue = metafieldValue.children[0].children[0].value || "";
                if(richTextValue) {
                    key.classList.remove('hidden');
                    //toggleHidden(key,"remove");
                    //key.querySelector('.metafield-rich_text_field p').textContent = richTextValue;
                    let badge = createBadgeElement(richTextValue);
                    customBadgesParent.appendChild(badge);
                } else {
                    key.classList.add('hidden');
                    //toggleHidden(key,"add");
                }
            } else {
                key.classList.add('hidden');
            }

            if(metafieldType == "list.single_line_text_field") {
                let listSingleTextValues = variantMetafields[metafieldKey];
                if(listSingleTextValues) {
                    key.classList.remove('hidden');
                    //toggleHidden(key,"remove");
                    listSingleTextValues.forEach((value) => {
                        let badge = createBadgeElement(value);
                        customBadgesParent.appendChild(badge);
                    });
                } else {
                    key.classList.add('hidden');
                    //toggleHidden(key,"add");
                }
            }
        });
    });

    function toggleHidden(element, method) {
        if(element.classList.contains("hidden")) {
            if(method == "remove") element.classList.remove("hidden");
            if(method == "add") return;
        }

        if(!element.classList.contains("hidden")) {
            if(method == "remove") return;
            if(method == "add") element.classList.add("hidden");
        }
    }

    function createBadgeElement(textContent) {
        let badge = document.createElement('span');
        badge.classList.add("custom-badge");
        badge.textContent = textContent;
        // console.log("Badge element", badge);
        return badge;
    }
});

